module.exports = __webpack_public_path__ + "img/我的日历.b09747f1.svg";